import React, { useState, useEffect } from 'react';
import { SelectFieldComponent } from '../common/SelectFieldComponent';
import { CatalogService } from '../../services/catalogService';
import { type Duenio } from '../../types/catalog';

interface DuenioSelectProps {
  value: number | string;
  onChange: (value: number) => void;
  label?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const DuenioSelect: React.FC<DuenioSelectProps> = ({
  value,
  onChange,
  label = 'Dueño',
  error,
  required = false,
  disabled = false,
  fullWidth = true,
}) => {
  const [duenios, setDuenios] = useState<Duenio[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDuenios();
  }, []);

  const loadDuenios = async () => {
    try {
      setLoading(true);
      const data = await CatalogService.getDuenios();
      setDuenios(data);
    } catch (error) {
      console.error('Error loading duenios:', error);
    } finally {
      setLoading(false);
    }
  };

  const options = duenios.map(duenio => ({
    value: duenio.id,
    label: `${duenio.nombres} ${duenio.apellidos}`,
  }));

  return (
    <SelectFieldComponent
      label={label}
      value={value}
      onChange={(val) => onChange(Number(val))}
      options={options}
      error={error}
      required={required}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      placeholder={loading ? 'Cargando...' : 'Seleccione un dueño'}
    />
  );
};
